import React from 'react';
import { FormHelperText, FormLabel, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import MUISelect from './MUISelect';
import { yearOptions, monthOptions } from './util';
import styles from './MonthYearSelect.styles';

const MonthYearSelect = ({ name, value, label, onDateChange, errors, classes }) => {
  const splitDate = value?.split('-') || [undefined, undefined];
  const year = splitDate[0];
  const month = splitDate[1];

  const handleChange = event => {
    const { name: targetName, value: targetValue } = event.target;
    if (targetName === 'year') {
      onDateChange(`${targetValue}-${month}`);
    } else {
      onDateChange(`${year}-${targetValue}`);
    }
  };

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <FormLabel error={errors[name]}>{label}</FormLabel>
      </Grid>
      <Grid item xs={6}>
        <FormLabel className={classes.visuallyHidden} htmlFor={`${name}Month`}>
          {label} Month
        </FormLabel>
        <MUISelect
          id={`${name}Month`}
          name="month"
          placeholder="Month"
          options={monthOptions}
          onChange={handleChange}
          value={month?.toString() || ''}
          inputDataTestId={`${name}-month-input`}
        />
      </Grid>
      <Grid item xs={6}>
        <FormLabel className={classes.visuallyHidden} htmlFor={`${name}Year`}>
          {label} Year
        </FormLabel>
        <MUISelect
          id={`${name}Year`}
          name="year"
          placeholder="Year"
          options={yearOptions()}
          onChange={handleChange}
          value={year?.toString() || ''}
          inputDataTestId={`${name}-year-input`}
        />
      </Grid>
      <Grid item xs={12}>
        <FormHelperText error={errors[name]}>{errors[name]?.error}</FormHelperText>
      </Grid>
    </Grid>
  );
};

MonthYearSelect.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    error: PropTypes.string,
  }),
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
};

MonthYearSelect.defaultProps = {
  errors: {},
};

export default withStyles(styles)(MonthYearSelect);
